// extracted by mini-css-extract-plugin
export var animationContainer = "_fd-0";
export var asteriskIcon = "_fd-8";
export var conversationLeftSection = "_fd-4";
export var conversationListItem = "_fd-3";
export var conversationMiddleSection = "_fd-5";
export var conversationRightSection = "_fd-6";
export var detailsContent = "_fd-1";
export var listContainer = "_fd-7";
export var modalContent = "_fd-2";